import axios from 'axios';
import { getBaseApiUrl, getRequestHeaders } from '../util/config';

export const getFaqs = async (
  category = 'all',
  topThreeOnly = false,
  searchCriteria = ''
) =>
  await axios.get(
    `${getBaseApiUrl()}/Contentful/FAQs/${encodeURIComponent(
      category
    )}?topThreeOnly=${topThreeOnly ? 'true' : 'false'}${
      searchCriteria ? `&searchCriteria=${searchCriteria}` : ''
    }`,
    {
      headers: getRequestHeaders(),
    }
  );
